/**
 * konstanty pro cesty Api volani
 */
export default {
    FILE_UPLOAD: '/Upload',
    BANKID: '/NZ/bankid',
    OBJEDNAT: '/NZ/objednat',
    PLATBA: '/NZ/platba',
    ZADOST: '/NZ/zadost',
    ZADOST_DOWNLOAD_PDF: '/NZ/zadost/DownloadPDF'
};
